import styled from "styled-components";
import { getColor, getSize } from "~/helpers/style";
import { UIProps } from "~/types/style";

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${getSize(2)};
  width: 100%;
  // margin-bottom: ${getSize(2)};

  @media (min-width: 1024px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const PageTitle = styled.h1`
  font-weight: 600;
  font-size: ${getSize(1.8)};
  line-height: ${getSize(2.4)};
  text-align: center;

  @media (min-width: 1024px) {
    text-align: left;
  }
`;

interface IPlansGrid extends UIProps {
  gap: number;
}

export const PlansGrid = styled.div<IPlansGrid>`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ gap }) => getSize(gap)};
  margin: 0 auto ${getSize(2)} auto;
  justify-content: center;
  align-items: stretch;
  width: 100%;
`;

export const ToggleContentText = styled.p`
  margin: 0;
  font-size: ${getSize(1.3)};
  font-weight: 500;
  line-height: ${getSize(2.0)};
  color: ${getColor("textDisabled")};

  &.selected {
    font-weight: 500;
    color: ${getColor("text")};
  }
`;

export const PromotionText = styled.div`
  position: relative;
  background-color: ${getColor("greenSecondary")};
  color: ${getColor("green")};
  margin: 0;
  padding: ${getSize(0.2)};
  padding: ${getSize(0.2)} ${getSize(1)};
  border-radius: ${getSize(0.5)};
  font-size: ${getSize(1.2)};
  font-weight: 500;
  line-height: ${getSize(1.83)};

  img {
    position: absolute;
    top: -${getSize(0.45)};
    right: ${getSize(12)};
  }
`;

export const AnnualDisclaimerBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${getSize(0.8)};
  background-color: ${getColor("bannerYellow")};
  color: ${getColor("text")};
  padding: ${getSize(1.2)} ${getSize(2)};
  border-radius: ${getSize(0.8)};
  margin-top: ${getSize(2)};
  font-size: ${getSize(1.4)};
  font-weight: 500;
  line-height: ${getSize(2)};
  width: 100%;
  max-width: ${getSize(60)};
`;
